import TableComponent from "./TableComponent";
import ConfigComponent from "../ConfigComponent";
import React, {FC, useState} from "react";
import {RadioComponent} from "../util/RadioComponent";
import FeedComponent from "../FeedComponent";
import LookSellExchange from "./LookSellExchange";
import ChartComponent from "../ChartComponent";
import ExchangeComponent from "./ExchangeComponent";
import {ReportComponent} from "./ReportComponent";



const SGBComponent:FC = () => {
    let [goldPrice, setGoldPrice] = useState(5134);
    let [focus, setFocus] = useState(true);
    let [stepBack, setStepBack] = useState(false);
    const [url, setUrl] = useState("")
    const[brs, setBRS] = useState(true);
    const [type, setType] = useState(1);

    return <>
        <ConfigComponent
            focus={focus}
            stepBack={stepBack}
            isLoggedIn={true}
            brs={brs}
        />
        <br/>
        <br/>
        <RadioComponent text="sgbs" actual={type} val={1} set={setType}/>&emsp;
        <RadioComponent text="feed" actual={type} val={2} set={setType}/>&emsp;
        <RadioComponent text="look sell exchange" actual={type} val={3} set={setType}/>&emsp;
        <RadioComponent text="chart" actual={type} val={4} set={setType}/>&emsp;
        <RadioComponent text="exchanges" actual={type} val={5} set={setType}/>&emsp;
        <RadioComponent text="reports" actual={type} val={6} set={setType}/>&emsp;
        <br/>
        <br/>
        {type===1 ? <TableComponent/> : <></>}
        {type===2 ? <FeedComponent/> : <></>}
        {type===3 ? <LookSellExchange/> : <></>}
        {type===4 ? <ChartComponent/> : <></>}
        {type===5 ? <ExchangeComponent/> : <></>}
        {type===6 ? <ReportComponent/> : <></>}

    </>
}

export default SGBComponent;
